import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, TransitionGroup as _TransitionGroup, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4710b050")

_pushScopeId("data-v-4710b050")
const _hoisted_1 = {
  key: 0,
  class: "item-not-selected"
}
const _hoisted_2 = {
  key: 1,
  class: "vue-content-remain-child"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("h3", null, "項目編集", -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode("項目名 ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("プレビュー ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("部品追加 ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_normal_edit_box = _resolveComponent("normal-edit-box")
  const _component_list_title = _resolveComponent("list-title")
  const _component_list_row = _resolveComponent("list-row")
  const _component_normal_button = _resolveComponent("normal-button")
  const _component_vue_head_button_frame = _resolveComponent("vue-head-button-frame")
  const _component_vue_y_scroll_area = _resolveComponent("vue-y-scroll-area")
  const _component_karte_option_modal = _resolveComponent("karte-option-modal")
  const _component_preview = _resolveComponent("preview")
  const _component_vue_content = _resolveComponent("vue-content")

  return (_openBlock(), _createBlock(_component_vue_content, { class: "vue-content-remain-child" }, {
    default: _withId(() => [
      (_ctx.selectedKarteItemIndex === -1)
        ? (_openBlock(), _createBlock("div", _hoisted_1, "左のリストから編集したいカルテ項目を選択してください。 "))
        : (_openBlock(), _createBlock("div", _hoisted_2, [
            _hoisted_3,
            _createVNode(_component_normal_edit_box, {
              placeholder: "無題(項目の名前を入力してください)",
              readonly: !_ctx.dataWrite,
              modelValue: _ctx.titles[_ctx.selectedKarteItemIndex],
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.titles[_ctx.selectedKarteItemIndex] = $event))
            }, {
              default: _withId(() => [
                _hoisted_4
              ]),
              _: 1
            }, 8, ["readonly", "modelValue"]),
            _createVNode(_component_list_title, {
              class: "parts-title",
              titles: _ctx.kartePartsTitles
            }, null, 8, ["titles"]),
            _createVNode(_component_vue_y_scroll_area, null, {
              default: _withId(() => [
                _createVNode(_TransitionGroup, null, {
                  default: _withId(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.kartePartsRow, (row, i) => {
                      return (_openBlock(), _createBlock(_component_list_row, {
                        key: row.id,
                        rowId: row.id,
                        columns: row.columns,
                        onClick: ($event: any) => (_ctx.onClick(i, $event)),
                        onPartsName: ($event: any) => (_ctx.onSelectPartsName(i, $event)),
                        onTitle: ($event: any) => (_ctx.onInputPartsTitle(i, $event)),
                        onOption: ($event: any) => (_ctx.onClick(i, { emitType: 'option' }))
                      }, null, 8, ["rowId", "columns", "onClick", "onPartsName", "onTitle", "onOption"]))
                    }), 128))
                  ]),
                  _: 1
                }),
                _createVNode(_component_vue_head_button_frame, { class: "parts-button-frame" }, {
                  default: _withId(() => [
                    _createVNode(_component_normal_button, {
                      class: "vue-head-button-frame-button",
                      state: "normal",
                      onClick: _ctx.onPreview
                    }, {
                      default: _withId(() => [
                        _hoisted_5
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_normal_button, {
                      class: "vue-head-button-frame-button",
                      state: "normal",
                      disabled: !_ctx.dataWrite,
                      onClick: _ctx.addKarteParts
                    }, {
                      default: _withId(() => [
                        _hoisted_6
                      ]),
                      _: 1
                    }, 8, ["disabled", "onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])),
      _createVNode(_component_karte_option_modal, { ref: "optionRef" }, null, 512),
      _createVNode(_component_preview, { ref: "previewRef" }, null, 512)
    ]),
    _: 1
  }))
})